// src/modules/IntegratedMessaging/adapters/CountriesApiAdapter.ts

import { HttpClient } from '@adapters/HttpClient';

export interface Country {
  id: number;
  name: string;
  iso2: string;
  iso3: string;
  phoneCode: string;
  createdAt: string;
  updatedAt: string;
}

export class CountriesApiAdapter {
  constructor(private httpClient: HttpClient) {}

  /** Trae todos los países (el endpoint devuelve un `Country[]` en la raíz) */
  async getAllCountries(): Promise<Country[]> {
    return await this.httpClient.get<Country[]>('/countries');
  }
}
